import React from 'react'
import './Divider.scss'

const Divider = ({noSpace}) => {
  return (
    <div className={`divider ${noSpace && "no-space"}`}></div>
  )
}

export default Divider
